import { useFetchData } from "../../../hooks/useFetchData";
import "./news.css";

function News() {
  const {data} = useFetchData("client-api/webpage");
  const currentDate = new Date();
  const day = currentDate.getDate();
  const month = currentDate.getMonth() + 1; // Months are zero-indexed
  const year = currentDate.getFullYear();
  const hours = currentDate.getHours();
  const minutes = currentDate.getMinutes();
  const formattedTime = `${day}/${month}/${year} ${hours}:${minutes < 10 ? '0' : ''}${minutes}`;

  return (
    <div className='news section-card df-c'>
        <div className="title df ">أخبار عاجلة <img src="https://th.bing.com/th/id/OIP.lduv8v6VWTyOdflEV156qAHaHa?w=198&h=199&c=7&r=0&o=5&dpr=1.3&pid=1.7" className='w-10 h-10' alt="" /></div>
        <p className='text'>
          {
            data?.webpages.mandoub.content
          }
        </p>
        <div style={{ position: 'absolute', bottom: 3, right: -10, width: '100%', textAlign: 'left' }}>
         التاريخ الحالي: {formattedTime}
      </div>
    </div>
  )
}

export default News
